import CachedInstance from "../cache/CachedInstance";
import Sprite from "../sprite/Sprite";
import { CharacterAction } from "./CharacterAction";
import CharacterTarget from "./CharacterTarget";
import Position from "./Position";
import TurnAction from "./turn/TurnAction";

/**
 * @abstract
 */
export default class Character extends CachedInstance {
    constructor() {
        super();

        /**
         * @constant
         * @type {Position}
         */
        this.position = new Position(this);

        /**
         * @constant
         * @type {CharacterTarget}
         */
        this.target = new CharacterTarget();

        /**
         * @type {TurnAction}
         */
        this.turnAction = null;

        /**
         * This is used by MonsterWanderBehavior to pause between moves
         * @type {number}
         */
        this.pathCompletedTime = 0;

        // /**
        //  * @type {string}
        //  */
        // this.debugText = '';
    }

    /**
     * @returns {boolean}
     */
    isMonster() {
        return true;
    }

    /**
     * @returns {boolean}
     */
    isPartyMember() {
        return false;
    }

    /**
     * @returns {boolean}
     */
    isMinion() {
        return false;
    }

    /**
     * @returns {boolean}
     */
    isDead() {
        return false;
    }

    // /**
    //  * @abstract
    //  * @param {Character} character 
    //  * @returns {boolean}
    //  */
    // isEnemy(character) {
    //     return true;
    // }

    /**
     * Returns -1 if this isn't a miner in the crew.
     * @abstract
     * @returns {number}
     */
    getMinerIndex() {
        return -1;
    }

    /**
     * @returns {string}
     */
    getMonsterDescriptionId() {
        return null;
    }

    /**
     * @returns {number}
     */
    getCharacterLevel() {
        return 1;
    }

    // /**
    //  * @abstract
    //  * @returns {number}
    //  */
    // getDamage() {
    //     return 1;        
    // }

    // /**
    //  * Reduce the character's health.
    //  * @param {number} health 
    //  */
    // decrementHealth(health) {
    //     if (health < 0) {
    //         console.log('Character.decrementHealth() negative health specified.');
    //         return;
    //     }
    //     this.health = Math.max(0, this.health - health);
    // }

    /**
     * @abstract
     * @param {string} characterAction  See CharacterAction
     */
    setCharacterAction(characterAction) {}

    /**
     * @abstract
     * @returns {Sprite}
     */
    getCharacterSprite() {
        return null;
    }

    /**
     * @abstract
     * @returns {Sprite}
     */
    getItemOverlaySprite() {
        return null;
    }

    /**
     * @abstract
     * @returns {boolean}
     */
    isThrusterActive() {
        return false;
    }

    /**
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     */
    followPathPlan(frameTimeRatio, turnStart) {
        if (this.position.pathPlan.length === 0) {
            return;
        }

        const plan = this.position.pathPlan[0];
        if (plan.executePlan(this, frameTimeRatio, turnStart)) {

            // We have completed a step in the plan.
            this.position.pathPlan.shift();

            if (this.position.pathPlan.length === 0) {
                this.pathCompletedTime = Date.now();
            }
        }
    }

    /**
     * @abstract
     */
    chooseTurn() {
        // Monsters still use this.
    }

    /**
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart
     */
    performFrameActions(frameTimeRatio, turnStart) {
        if (!this.turnAction) {
            return;
        }

        this.turnAction.performAction(this, frameTimeRatio, turnStart);
    }

    /**
     * 
     */
    resetTurnState() {
        this.turnAction = null;
        this.characterAction = CharacterAction.STAND;
        this.target.resetTarget();
        this.position.resetPathPlan(); // this also resets the position to the tile origin.
    }

    ///////////////////////////////////////////////
    // 
    ///////////////////////////////////////////////

    /**
     * Invoked if the character is found to be in a grid that was unloaded.
     * We do not want the character to retain references to tiles that are in a grid
     * that was recycled and moved.
     */
    onInvalidGrid() {
        this.resetGameModel();
    }

    resetGameModel() {
        this.position.resetFull();
        this.resetTurnState();
    }
}